import script from "./HintComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HintComponent.vue?vue&type=script&setup=true&lang=js"

import "./HintComponent.vue?vue&type=style&index=0&id=31fde1ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fde1ec"]])

export default __exports__